// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__1ukFy","head":"Home_head__2zc93","empty":"Home_empty__ZmSfG","gradient":"Home_gradient__3TSIX"};